import * as React from 'react';
import * as Styled from './WhatYouGet.styles';
import Heading from '@ids/components/Typography/Heading';
import Text from '@ids/components/Typography/Text';
import { useWhatYouGetBlock } from '@ids/context';
import AspectRatio from '@ids/components/Layout/AspectRatio';
import Divider from '@ids/components/Layout/Divider';
import Skeleton from '@ids/components/Layout/Skeleton';

const WhatYouGet = () => {
    const whatYouGetBlock = useWhatYouGetBlock();

    if (!whatYouGetBlock) {
        return <Skeleton height="60vh" />;
    }

    return (
        <React.Fragment>
            <Styled.WhatYouGetSection data-testid="what-you-get-block-section" id="what-you-get">
                <Styled.TextBox>
                    <Heading>{whatYouGetBlock.title}</Heading>
                    <Text>{whatYouGetBlock.contentText}</Text>
                </Styled.TextBox>
                <AspectRatio ratio={4 / 3}>
                    <Styled.Media
                        media={whatYouGetBlock.idsMedia}
                        image={{ sizes: '(max-width: 767px) 100vw, 50vw' }}
                    />
                </AspectRatio>
            </Styled.WhatYouGetSection>
            <Divider />
        </React.Fragment>
    );
};

export default WhatYouGet;
